/**
 * Initialize Swiper carousels in the block editor
 */
(function() {
    // Function to initialize Swiper instances
    function initSwipers() {
        // Target the block editor content
        const blockEditor = document.querySelector('.editor-styles-wrapper');
        if (!blockEditor) return;
        
        // Initialize Logo Carousels
        initLogoCarousels(blockEditor);
        
        // Initialize Testimonials Carousels
        initTestimonialCarousels(blockEditor);
        
        // Initialize any other carousel types
    }
    
    // Logo carousel initialization
    function initLogoCarousels(container) {
        const logoCarousels = container.querySelectorAll('.logo-carousel-block .swiper');
        
        if (logoCarousels.length === 0) return;
        
        logoCarousels.forEach(function(swiperEl) {
            // Skip if already initialized
            if (swiperEl.swiper) return;
            
            // Get configuration options from data attributes if available
            const slidesPerView = parseInt(swiperEl.getAttribute('data-slides-per-view') || 6, 10);
            
            // Initialize Swiper
            new Swiper(swiperEl, {
                slidesPerView: 3,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: swiperEl.parentElement.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.parentElement.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.parentElement.querySelector('.swiper-button-prev'),
                },
                breakpoints: {
                    576: { slidesPerView: 2, spaceBetween: 20 },
                    768: { slidesPerView: 3, spaceBetween: 30 },
                    992: { slidesPerView: 4, spaceBetween: 30 },
                    1200: { slidesPerView: slidesPerView, spaceBetween: 30 }
                }
            });
        });
    }
    
    // Testimonials carousel initialization
    function initTestimonialCarousels(container) {
        const testimonialCarousels = container.querySelectorAll('.testimonials-block .swiper');
        
        if (testimonialCarousels.length === 0) return;
        
        testimonialCarousels.forEach(function(swiperEl) {
            // Skip if already initialized
            if (swiperEl.swiper) return;
            
            // Initialize Swiper
            new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: swiperEl.parentElement.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperEl.parentElement.querySelector('.swiper-button-next'),
                    prevEl: swiperEl.parentElement.querySelector('.swiper-button-prev'),
                }
            });
        });
    }
    
    // Initialize when WordPress is ready
    if (typeof wp !== 'undefined' && wp.domReady) {
        wp.domReady(function() {
            // Initial initialization with delay to ensure DOM is ready
            setTimeout(initSwipers, 1000);
            
            // Re-initialize when blocks change or editor updates
            let observer = new MutationObserver(function(mutations) {
                setTimeout(initSwipers, 500);
            });
            
            // Start observing the editor for changes
            const blockEditor = document.querySelector('.editor-styles-wrapper');
            if (blockEditor) {
                observer.observe(blockEditor, { 
                    childList: true,
                    subtree: true 
                });
            }
        });
    } else {
        // Fallback to standard DOM ready
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initSwipers, 1000);
            
            let observer = new MutationObserver(function(mutations) {
                setTimeout(initSwipers, 500);
            });
            
            const blockEditor = document.querySelector('.editor-styles-wrapper');
            if (blockEditor) {
                observer.observe(blockEditor, { 
                    childList: true,
                    subtree: true 
                });
            }
        });
    }
})();